var _path, _path2, _path3, _circle, _circle2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIndiaFlagIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    className: "iconify iconify--emojione",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.8 2c-13 0-24.1 8.4-28.2 20h56.6C56 10.4 44.9 2 31.8 2z",
    fill: "#f2b200"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8 62c13.1 0 24.2-8.3 28.3-20H3.6c4.1 11.7 15.2 20 28.2 20z",
    fill: "#83bf4f"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.6 22c-1.1 3.1-1.7 6.5-1.7 10s.6 6.9 1.7 10h56.6c1.1-3.1 1.7-6.5 1.7-10s-.6-6.9-1.7-10H3.6",
    fill: "#ffffff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.8,
    cy: 32,
    r: 8,
    fill: "#428bc1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.8,
    cy: 32,
    r: 7,
    fill: "#ffffff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#428bc1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 29.2,
    cy: 25.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.6,
    cy: 26.4,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.3,
    cy: 27.7,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.4,
    cy: 29.3,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.9,
    cy: 31.1,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.9,
    cy: 32.9,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.4,
    cy: 34.7,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.3,
    cy: 36.3,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.6,
    cy: 37.6,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.2,
    cy: 38.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.9,
    cy: 38.9,
    r: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3 39c0-.3.2-.5.4-.6c.3 0 .5.2.6.4c0 .3-.2.5-.4.6c-.4.1-.6-.1-.6-.4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 38.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.1,
    cy: 37.6,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.4,
    cy: 36.3,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.3,
    cy: 34.7,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.8,
    cy: 32.9,
    r: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8 31.6c-.3 0-.5-.2-.6-.4c0-.3.2-.5.4-.6c.3 0 .5.2.6.4c.1.3-.1.5-.4.6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.3,
    cy: 29.3,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.4,
    cy: 27.7,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.1,
    cy: 26.4,
    r: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 25.7c-.1.3-.4.4-.7.3c-.3-.1-.4-.4-.3-.7c.1-.3.4-.4.7-.3c.3.2.4.5.3.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2 25.1c0 .3-.3.5-.6.4c-.3 0-.5-.3-.4-.6c0-.3.3-.5.6-.4c.3.1.5.4.4.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4 25c0 .3-.2.5-.4.6c-.3 0-.5-.2-.6-.4c0-.3.2-.5.4-.6c.3-.1.6.1.6.4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.8,
    cy: 32,
    r: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8 25l-.2 4.3l.2 2.7l.3-2.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 25.2l.9 4.3l.9 2.5l-.4-2.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3 25.9l2 3.9l1.5 2.2l-1.1-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9 27l2.9 3.3l2 1.7l-1.7-2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8 28.5l3.6 2.4l2.4 1.1l-2.2-1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1 30.2l4.1 1.3l2.6.5l-2.5-.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8 32l4.4.2l2.6-.2l-2.6-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1 33.8l4.2-.9l2.5-.9l-2.6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8 35.5l3.8-1.9l2.2-1.6l-2.4 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9 36.9l3.2-2.8l1.7-2.1l-2 1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3 38.1l2.4-3.7l1.1-2.4l-1.5 2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 38.8l1.4-4.1l.4-2.7l-.9 2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8 39l.3-4.3l-.3-2.7l-.2 2.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6 38.8l-.8-4.3l-1-2.5l.5 2.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3 38.1l-1.9-3.9l-1.6-2.2l1.2 2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8 36.9l-2.9-3.2l-2.1-1.7l1.8 2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9 35.5l-3.6-2.4l-2.5-1.1l2.2 1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6 33.8l-4.1-1.3l-2.7-.5l2.6.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8 32l-4.3-.3l-2.7.3l2.7.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6 30.2l-4.2.9l-2.6.9l2.7-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9 28.5L34 30.4L31.8 32l2.5-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8 27.1l-3.2 2.8l-1.8 2.1l2.1-1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3 25.9L33 29.6L31.8 32l1.6-2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7 25.2l-1.4 4.1l-.5 2.7l1-2.5z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndiaFlagIcon);
export default __webpack_public_path__ + "static/media/india-flag-icon.de2675aa6563ca2cbcea7bf12ff3033f.svg";
export { ForwardRef as ReactComponent };